import * as mod from 'common-ui/lib/common/_helper/AnimationTheme/AnimationThemeProvider';

export default mod.default;
